import React from 'react';
import './AppFooter.css';
import { Col, Divider, Row} from 'antd';
import img from "../../assets/img.svg";
import '../header/AppHeader.css';
import { FacebookOutlined,InstagramOutlined,TwitterOutlined,LinkedinOutlined } from '@ant-design/icons';
import {Space} from 'antd';
import { FooterItem } from './FooterItem.js';
import { FACEBOOK_LINK, HEADER_TITLE, INSTAGRAM_LINK, LINKEDIN_LINK, TWITTER_LINK } from '../properties/properties.js';

export const AppFooter = ({scrollToSection, isMobile}) => {

    const handleFooterClick = (section) => {
        scrollToSection.current(section);
    };

    return (
        <div className='footer-page'>
            |
            <Divider className='footer-divider'/>
            <Row className='footer-logo' style={{flexDirection:!isMobile ? "row-reverse" : "row"}}>
                <Col style={{width:isMobile ? '100%' : "",display:'flex', alignItems:'center', justifyContent:'flex-end',marginRight:"7%"}}>
                    <Space size={20} style={{fontSize:"x-large", padding: isMobile ? "10px" : ""}}>
                        <a 
                            href={INSTAGRAM_LINK}
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }} // Optional: Removes underline if needed
                            >
                            <InstagramOutlined style={{backgroundColor:'red',color:'white',borderRadius:'5%'}}/>
                        </a>
                        <a 
                            href={FACEBOOK_LINK}
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }} // Optional: Removes underline if needed
                            >
                            <FacebookOutlined style={{backgroundColor:'blue',color:'white',borderRadius:'5%'}}/>
                        </a>
                        <a 
                            href={TWITTER_LINK}
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }} // Optional: Removes underline if needed
                            >
                            <TwitterOutlined style={{backgroundColor:'blue',color:'white',borderRadius:'50%'}}/>
                        </a>
                        <a 
                            href={LINKEDIN_LINK}
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }} // Optional: Removes underline if needed
                        >
                            <LinkedinOutlined style={{backgroundColor:'rgb(73,73,182)',borderRadius:'7%',color:'white'}}/>
                        </a>
                    </Space>
                </Col>
                <Col className="title-container" style={isMobile ? {paddingLeft: "10px"} : {paddingLeft:'50px'}}>
                    <img src={img} alt='Logo' className='app-logo'></img>
                    <div className='main-title'>{HEADER_TITLE}</div>
                </Col>
            </Row>
            <div>
                <Row className='row-ref'>
                    <Col><FooterItem scrollToSection={scrollToSection} footerTitle="Company" footerRefs={["About", "Careers", "Contact"]} footerItems={["About Us","Careers","Contact Us"]}/></Col>
                    <Col>
                        <FooterItem divSection={"Services"} scrollToSection={scrollToSection} footerTitle="Features" footerItems={[
                                "Online Court Reservation",
                                "Tournament Planner",
                                "Membership Management",
                                "Realtime Dashboards",
                                "Realtime Notifications",
                                "Student Progress Tracker",
                                "Inventory management",
                                "Inbuilt POS" 
                            ]} footerRefs={[
                                "courtReservationRef",
                                "trournamentPlannerRef",
                                "membershipManagementRef",
                                "dashbordsRef",
                                "notificationsRef",
                                "studentProgressRef",
                                "inventoryManagementRef",
                                "inbuiltPosRef"
                            ]}
                        />
                    </Col>
                    <Col><FooterItem footerTitle="Resources" footerItems={["Demo Video","Blog","News Letters"]}/></Col>
                    <Col><FooterItem footerTitle="Contact Us" divSection={"socialMedia"} footerRefs={[FACEBOOK_LINK, INSTAGRAM_LINK]} footerItems={["Facebook","Instagram","Phone","Live Chat"]}/></Col>
                    <Col><FooterItem footerTitle="FAQs" footerItems={[
                        "How to contact Us",
                        "What is the pricing model",
                        "Questions on Subscription",
                        "All other Questions"]}/></Col>
                </Row> 
            </div>
             <p className='copy-rights'> &copy; All rights reserved, ClubSportsSolutions L.L.C.</p>
        </div>
    );
};
